'use client';
import Button from '@/components/Button';
import TextDisplay from '@/components/legals/TextDisplay';

import Errors from '@/services/errors';
import { fetchMessage } from '@/services/messages';
import { compareSessionId, setSessionId } from '@/services/register';
import { useSearchParams } from 'next/navigation';
import { useContext, useEffect, useState } from 'react';
import { ToastContext } from '../Layout';

const LegalDoc = ({ id }) => {
  const updateToast = useContext(ToastContext);
  const [message, setMessage] = useState('');
  const [sessionId, setSessionIdState] = useState('');
  const [sessionSessionToken, setSessionSessionToken] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);
  const searchParams = useSearchParams();

  const subscribe = searchParams.get('subscribe') === '1';

  const handleAccept = (e) => {
    const acceptForm = document.getElementById('accept__form');
    const acceptButton = acceptForm.querySelector('button[type="submit"]');
    if (e.target.checked) {
      acceptButton.disabled = false;
    } else {
      acceptButton.disabled = true;
    }
  };
  const handleAcceptConditionsSubmit = async (e) => {
    // call api with sessionID and if valid redirect to register form
    e.preventDefault();
    try {
      const canMoveForward = await compareSessionId(sessionId, sessionSessionToken);
      if (canMoveForward) {
        window.location.href = '/confirmation-enregistrement?uid=' + sessionId;
      }
    } catch (e) {
      Errors.handleError(e, updateToast);
    }
  };

  useEffect(() => {
    try {
      fetchMessage(id).then((data) => setMessage(data));
      setSessionId().then(({ data, cookieValue }) => {
        setSessionIdState(data);
        setSessionSessionToken(cookieValue);
      });
    } catch (e) {
      Errors.handleError(e, updateToast);
    }
  }, [id]);

  return (
    <>
      <div className={`card card-1-light m-1 m-md-2 m-lg-4 pt-2 ${isLoaded ? '' : 'd-none'}`}>
        {subscribe && (
          <div className="card-title">
            <h2 className={'fs-1 text-center'}>S&apos;inscrire - Conditions d&apos;utilisation</h2>
          </div>
        )}
        <div className="card-body">
          {subscribe && <h3 className={'mb-3'}>Veuillez lire et approuver les conditions d&apos;utilisation.</h3>}
          <TextDisplay message={message} loadedState={[isLoaded, setIsLoaded]} />
        </div>
        {subscribe && (
          <div className="card-footer">
            <form id="accept__form" onSubmit={(e) => handleAcceptConditionsSubmit(e)}>
              <div className="d-flex form-group align-items-center">
                <input
                  id="accept"
                  className="form-check-input m-0 position-relative mb-0"
                  type="checkbox"
                  name="accept"
                  required
                  onChange={(e) => handleAccept(e)}
                />
                <label className="ms-2 mb-0" htmlFor={'accept'}>
                  J&apos;ai lu et accepté les conditions d&apos;utilisation
                </label>
              </div>
              <div className="mt-2 form-group">
                <Button type="submit" className="btn btn-success" disabled>
                  S&apos;inscrire
                </Button>
              </div>
            </form>
          </div>
        )}
      </div>
    </>
  );
};

export default LegalDoc;
